// 导入封装好的 axios 实例
import request from '@/utils/request'

//设备接口开始
//设备管理列表接口
export function deviceInfo(data) {
  return request({
    url: '/program/equipment/page',
    method: 'post',
    data
  })
}

//设备类型接口
export function categoryInfo(data) {
  return request({
    url: '/program/category/page',
    method: 'post',
    data
  })
}

//添加设备接口
export function addDevice(data) {
  return request({
    url: '/program/equipment',
    method: 'post',
    data
  })
}

//删除设备接口
export function delDevice(id) {
  return request({
    url: `/program/equipment/${id}`,
    method: 'delete',
  })
}

//添加设备接口-----使用模板
export function addequipmnet(data) {
  return request({
    url: 'program/equipment/template/add/equipment',
    method: 'post',
    data
  })
}


// 设备分类
export function categoryPage(data) {
  return request({
    url: 'program/category/page',
    method: 'post',
    data
  })
}

//上传图片
export function updoadImg(data) {
  return request({
    url: 'sys/upload/file/upload/bucket/name?bucketName=equipment',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

export function uploadCert(data) {
  return request({
    url: 'sys/upload/file/upload/bucket/name?bucketName=certify',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}


//新建设备类别/编辑
export function addCategory(data) {
  return request({
    url: '/program/category',
    method: 'post',
    data
  })
}


//删除设备类型
export function delCategory(id) {
  return request({
    url: `/program/category/${id}`,
    method: 'delete',
  })
}


//设备分类详情
export function categoryDetail(id) {
  return request({
    url: `/program/category/${id}`,
    method: 'get',
  })
}

// 上级分类
export function topCategory() {
  return request({
    url: `/program/top/category/list`,
    method: 'get',
  })
}

export function categoryTree() {
  return request({
    url: `/program/top/category/node`,
    method: 'get',
  })
}

export function saveTopCategory(data) {
  return request({
    url: '/program/top/category',
    method: 'post',
    data
  })
}
export function updateTopCategory(data) {
  return request({
    url: '/program/top/category',
    method: 'put',
    data
  })
}










//设备接口结束*******************************************************


//传感器开始
//设备---传感器列表接口
export function sensorInfo(data) {
  return request({
    url: '/program/sensor/page',
    method: 'post',
    data
  })
}


//传感器类型接口
export function sensorTypeList(data) {
  return request({
    url: '/program/sensor/type/page',
    method: 'post',
    data
  })
}


//添加传感器接口
export function addSensor(data) {
  return request({
    url: '/program/sensor',
    method: 'post',
    data
  })
}

//删除传感器接口
export function delSensor(id) {
  return request({
    url: `/program/sensor/${id}`,
    method: 'delete',
  })
}
